import { VariantProps, cva } from 'class-variance-authority'
import React, { HTMLAttributes, PropsWithChildren } from 'react'

import { useStore } from '@frame/lib/stores/useStore'
import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

const variants = cva('border-1.5', {
  variants: {
    size: {
      small: 'rounded-md',
      large: 'rounded-lg',
    },
    intent: {
      default: 'bg-white',
      primary: 'bg-electric-200',
      secondary: 'bg-moss-100',
    },
    border: {
      true: 'border-moss-200 bg-white',
      false: 'border-none',
    },
    applyCobranding: {
      true: 'bg-cobranding-hover',
    },
  },
  compoundVariants: [
    {
      intent: 'primary',
      applyCobranding: true,
      border: false,
      className: 'bg-cobranding-hover',
    },
    {
      intent: 'secondary',
      applyCobranding: true,
      className: 'bg-moss-100',
    },
  ],
  defaultVariants: {
    size: 'small',
    intent: 'default',
    border: false,
    applyCobranding: false,
  },
})

export type CardProps = {
  size?: VariantProps<typeof variants>['size']
  intent?: VariantProps<typeof variants>['intent']
  border?: boolean
  className?: HTMLAttributes<HTMLParagraphElement>['className']
  'data-cy'?: string
}

export function Card({ size, intent, border, className, children, ...rest }: PropsWithChildren<CardProps>) {
  const cobrandingColor = useStore((state) => state.session?.configuration.cobranding.button_color)

  return (
    <div
      data-cy={rest['data-cy'] ?? PrimitiveDataAttribute.TW_PRIMITIVE_CARD}
      className={cn(className, variants({ size, intent, border, applyCobranding: !!cobrandingColor }))}
    >
      {children}
    </div>
  )
}
